export default __webpack_public_path__ + "static/media/PendingIcon.724e0f0f.png";